import { render, staticRenderFns } from "./StockPrint5.vue?vue&type=template&id=2efe7ac2&scoped=true&"
import script from "./StockPrint5.vue?vue&type=script&lang=js&"
export * from "./StockPrint5.vue?vue&type=script&lang=js&"
import style0 from "./StockPrint5.vue?vue&type=style&index=0&id=2efe7ac2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efe7ac2",
  null
  
)

export default component.exports